import { ApolloError } from '@apollo/client';
import { AccommodationCatalogPropertyIdentifierV2Type, useTravelReservationSummariesByPropertyIdentifiersQuery } from '@graphql/generated';
import { useFeatureValue } from '@shared/core/featureFlags';
import { addError } from '@shared/utils/logger';

export const useTravelReservationsSummary = (joyPlaceIds: string[]) => {
  const { value: bookingCountExperimentValue, loading: loadingBookingCountExperiment, payload: bookingCountExperimentPayload } = useFeatureValue('bookingCountExperiment');
  const isBookingCountExperimentEnabled = bookingCountExperimentValue === 'treatment';
  const { data: reservationSummariesData } = useTravelReservationSummariesByPropertyIdentifiersQuery({
    variables: {
      payload: {
        identifiers: [...joyPlaceIds.map(id => ({ type: AccommodationCatalogPropertyIdentifierV2Type.joyPlace, id }))],
        afterDate: '2024-01-01',
      },
    },
    onError(error: ApolloError) {
      addError(error, {
        source: 'Reservation summaries api failed',
        context: 'travelReservationSummariesByPropertyIdentifiers',
        errorMessage: error.message,
        propertyIds: joyPlaceIds,
        propertyType: AccommodationCatalogPropertyIdentifierV2Type.joyPlace,
      });
    },
    batchMode: 'fast',
    skip: !joyPlaceIds.length || !isBookingCountExperimentEnabled || loadingBookingCountExperiment,
  });

  const getReservationsCountData = (joyPlaceId?: Maybe<string>) => {
    if (!joyPlaceId || !isBookingCountExperimentEnabled || loadingBookingCountExperiment) return null;

    const reservationSummary = reservationSummariesData?.travelReservationSummariesByPropertyIdentifiers?.reservationSummaries?.find(
      summary => summary.identifier.id === joyPlaceId,
    );

    if (
      reservationSummary?.reservationsCount &&
      reservationSummary?.reservationsCount < (bookingCountExperimentPayload as { bookingCountThreshold: number }).bookingCountThreshold
    ) {
      return null;
    }

    return reservationSummary?.reservationsCount;
  };

  return { getReservationsCountData };
};
